import React, { useState, useEffect } from "react";
import BASE_URL from "../../configs/api";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { toast } from "react-toastify"; // Sử dụng toast từ react-hot-toast
import { Link } from "react-router-dom";
const FavoriteMovies = () => {
  const [favoriteMoviesData, setFavoriteMoviesData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    axios
      .get(`${BASE_URL}/api/yeuthich/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setFavoriteMoviesData(res.data.results);
      })
      .catch((err) => {
        console.error("Lỗi lấy danh sách yêu thích:", err);
      });
  }, []);

  const handleRemoveMovie = (slug) => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    axios
      .post(
        `${BASE_URL}/api/yeuthich/remove-phim/`,
        { phim_slug: slug },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        toast.success("Xóa phim khỏi danh sách yêu thích thành công!");
        setFavoriteMoviesData(
          favoriteMoviesData.filter((item) => item.phim.slug !== slug)
        );
      })
      .catch((err) => {
        toast.error("Lỗi xóa phim khỏi danh sách yêu thích");
      });
  };

  return (
    <div className="min-h-[80vh]">
      <h2 className="text-xl md:text-2xl font-bold text-white mb-5">
        Yêu thích
      </h2>

      <div className="mb-6">
        <button className="px-5 py-2 mr-3 rounded-full text-sm font-medium transition-colors duration-200 bg-gray-200 text-black">
          Phim ({favoriteMoviesData.length})
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
        {favoriteMoviesData.map((item) => {
          const movie = item.phim;
          return (
            <div
              key={movie.id}
              className="movie-card transition-transform duration-200 ease-in-out"
            >
              <div className="relative rounded-lg overflow-hidden group">
                <Link to={`/phim/${movie.slug}`}>
                  <div className="relative">
                    <img
                      src={movie.poster_url}
                      alt={movie.ten_phim}
                      className="w-full h-auto aspect-[2.2/3] object-fill"
                    />
                    <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300" />
                  </div>
                </Link>

                {/* Nút xóa */}
                <button
                  className="absolute top-2 right-2 bg-[#fff] hover:bg-neutral-100 text-black rounded-[5px] w-8 h-8 flex items-center justify-center transition-colors duration-200 z-2 opacity-[0.7]"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveMovie(movie.slug);
                  }}
                >
                  <IoClose className="h-4 w-4" />
                </button>
              </div>

              <div className="mt-2 text-center">
                <Link
                  to={`/phim/${movie.slug}`}
                  className="text-white text-sm font-medium truncate hover:text-yellow-200 cursor-pointer line-clamp-none"
                  title={movie.ten_phim}
                >
                  {movie.ten_phim}
                </Link>
                <p
                  className="text-gray-400 text-xs truncate line-clamp-none"
                  title={movie.ten_khac}
                >
                  {movie.ten_khac}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FavoriteMovies;
